import { metaForListing } from '@/lib/head';
import { UI } from '@/lib/ui-strings';
import Head from '@/components/Head';
import SmartLink from '@/components/SmartLink';

export default function NotFound() {
  const meta = metaForListing({
    title: `${UI.notFoundTitle} – Health Prime`,
    description: UI.notFoundBody,
    route: '/404',
    robots: 'noindex, follow',
  });
  return (
    <>
      <Head meta={meta} />
      <div className="hp-page hp-page--404">
        <h1 className="hp-page__title">{UI.notFoundTitle}</h1>
        <p className="hp-page__lead">{UI.notFoundBody}</p>
        <p>
          <SmartLink to="/" className="hp-button hp-button--solid">
            {UI.notFoundAction}
          </SmartLink>
        </p>
      </div>
    </>
  );
}
